// @flow

import type {
  ContactUs,
} from 'hfty-model-contact-us'

// Operator
import composeOperator from '../operator'

// Effect Managers
import { call, fork, put, race, select, take } from 'redux-saga/effects'

// Constants
import { URL } from 'hfty-model-contact-us'

// Utils
import { __post } from 'hfty-fetch'

import operations$ from 'hfty-contact-us/src/selectors/contactUs'

const operator = composeOperator()

// Exports
export default function *watchOperations (): Generator<*, void, *> {
  yield fork(handleOperations)
}

export function *handleOperations (): Generator<*, void, *> {
  while (true) {
    const effect = yield race({
      submit: take(operator.actionTypes.submitOperations()),
      cancel: take(operator.actionTypes.cancelOperations()),
    })
    if (effect.submit) {
      yield call(handleSubmitOperations)
    }
  }
}

export function *handleSubmitOperations (): Generator<*, boolean, *> {
  let operations = yield select(operations$)

  operations = {
    ...operations,
    submitting: true,
  }

  const nextOperations = yield call(handleSubmitOperation, operations)
  return nextOperations.success
}

export function *handleSubmitOperation (operation: ContactUsOperation): Generator<*, ContactUsOperation, *> {
  const model: ContactUs = operation.model

  try {
    const response = yield call(__post, {
      path: URL,
      body: model,
    })
    if (response.status >= 200 && response.status < 300) {
      const nextOperation = {
        ...operation,
        model: null,
        submitting: false,
        success: true,
      }
      const action = operator.actionCreators.updateOperation(nextOperation)
      yield put(action)

      return nextOperation
    } else {
      const nextOperation = {
        ...operation,
        submitting: false,
        success: false,
        errors: response,
      }

      const action = operator.actionCreators.updateOperation(nextOperation)
      yield put(action)

      return nextOperation
    }
  } catch (e) {
    console.warn('There has been an error requesting to send contact us message.')
  }
}
